function qtpInit(sectionEl) {
  var track     = sectionEl.querySelector('.qtp-track');
  var dotsWrap  = sectionEl.querySelector('.qtp-dots');
  var fadeLeft  = sectionEl.querySelector('.qtp-fade-left');
  var fadeRight = sectionEl.querySelector('.qtp-fade-right');
  if (!track || !dotsWrap) return;

  var cards = track.querySelectorAll('.qtp-card');
  var total = cards.length;

  var cfgVisible    = parseInt(sectionEl.dataset.visible)       || 5;
  var cfgVisibleMob = parseInt(sectionEl.dataset.visibleMobile) || 2;
  var cfgGap        = parseInt(sectionEl.dataset.gap)           || 16;
  var cfgImgH       = parseInt(sectionEl.dataset.imgH)          || 200;
  var cfgImgHMob    = parseInt(sectionEl.dataset.imgHMob)       || 148;
  var cfgImgR       = parseInt(sectionEl.dataset.imgR)          || 12;
  var showFade      = sectionEl.dataset.showFade === 'true';

  var cardW   = 0;
  var visible = cfgVisible;
  var dots    = [];

  function buildDots() {
    dotsWrap.innerHTML = '';
    dots = [];
    for (var i = 0; i < total; i++) {
      var d = document.createElement('div');
      d.className = 'qtp-dot' + (i < visible ? ' active' : '');
      d.dataset.index = i;
      dotsWrap.appendChild(d);
      dots.push(d);
    }
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        track.scrollTo({ left: parseInt(dot.dataset.index) * cardW, behavior: 'smooth' });
      });
    });
  }

  function setCardWidths() {
    var mob = window.innerWidth <= 768;
    visible = mob ? cfgVisibleMob : cfgVisible;
    var w   = Math.floor((track.clientWidth - cfgGap * (visible - 1)) / visible);
    var h   = mob ? cfgImgHMob : cfgImgH;
    cardW   = w + cfgGap;

    cards.forEach(function(card) {
      card.style.width    = w + 'px';
      card.style.minWidth = w + 'px';
      card.style.maxWidth = w + 'px';
      var img = card.querySelector('.qtp-img');
      if (img) {
        img.style.width        = w + 'px';
        img.style.height       = h + 'px';
        img.style.borderRadius = cfgImgR + 'px';
      }
    });

    buildDots();
    updateDots();
    updateFades();
  }

  function updateDots() {
    if (!dots.length || cardW === 0) return;
    var first = Math.round(track.scrollLeft / cardW);
    first = Math.max(0, Math.min(first, total - visible));
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i >= first && i < first + visible);
    });
  }

  function updateFades() {
    if (!fadeLeft || !fadeRight) return;
    if (!showFade) { fadeLeft.style.display = 'none'; fadeRight.style.display = 'none'; return; }
    var atStart = track.scrollLeft <= 2;
    var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    fadeLeft.style.display  = atStart ? 'none' : 'block';
    fadeRight.style.display = atEnd   ? 'none' : 'block';
  }

  function onScroll() { updateDots(); updateFades(); }

  track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setCardWidths);
  setCardWidths();
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[id^="qtp-"]').forEach(qtpInit);
});

document.addEventListener('shopify:section:load', function(e) {
  var sectionEl = e.target.querySelector('[id^="qtp-"]');
  if (sectionEl) qtpInit(sectionEl);
});

document.addEventListener('shopify:section:reorder', function(e) {
  var sectionEl = e.target.querySelector('[id^="qtp-"]');
  if (sectionEl) qtpInit(sectionEl);
});